import { useEntrance } from '@/components/entrance-tracker/context/entrance-context';
import { WARP_SONG_ENTRANCE_IDS, resolveWarpArrivalZone } from '@/ootr/warp/entrance-bridge';
import Minuet from '@/core/assets/oot/gshd/minuet_32x32.png';
import Bolero from '@/core/assets/oot/gshd/bolero_32x32.png';
import Serenade from '@/core/assets/oot/gshd/serenade_32x32.png';
import Requiem from '@/core/assets/oot/gshd/requiem_32x32.png';
import Nocturne from '@/core/assets/oot/gshd/nocturne_32x32.png';
import Prelude from '@/core/assets/oot/gshd/prelude_32x32.png';

const SONG_IMAGES: Record<string, string> = {
    'Minuet of Forest': Minuet,
    'Bolero of Fire': Bolero,
    'Serenade of Water': Serenade,
    'Nocturne of Shadow': Nocturne,
    'Requiem of Spirit': Requiem,
    'Prelude of Light': Prelude,
};

export function WarpSongDestinations() {
    const { state } = useEntrance();

    const rows = WARP_SONG_ENTRANCE_IDS.map(({ song, entranceId }) => ({
        song,
        destination: resolveWarpArrivalZone(state.connections[entranceId]?.actualDestination),
    }));

    const hasAnyTracked = rows.some((r) => r.destination);
    if (!hasAnyTracked) return null;

    return (
        <section className="bg-gray-900/50 border border-cyan-900/30 rounded-xl px-3 py-1.5 self-stretch">
            <div className="flex items-center gap-2 mb-1">
                <h2 className="text-xs font-semibold text-cyan-400 uppercase tracking-wider">
                    Warp Songs
                </h2>
            </div>
            <div className="grid grid-cols-1 gap-0.5">
                {rows.map(({ song, destination }) => (
                    <div
                        key={song}
                        className={`flex items-center gap-2 text-xs ${
                            destination ? 'text-gray-200' : 'text-gray-500'
                        }`}
                    >
                        <img
                            src={SONG_IMAGES[song]}
                            alt={song}
                            className="w-5 h-5"
                            style={{ imageRendering: 'pixelated' }}
                        />
                        <span className="font-medium">{song}</span>
                        <span className="text-gray-400">
                            {destination ? `→ ${destination}` : '— ?'}
                        </span>
                    </div>
                ))}
            </div>
        </section>
    );
}
